"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var FlatfileUpload_1 = __importDefault(require("components/FlatfileUpload/FlatfileUpload"));
var Text_1 = __importDefault(require("shared/components/Text"));
var useUploadTransactions_1 = require("./useUploadTransactions");
var UploadPopover = function (_a) {
    var company = _a.company;
    var _b = __read(react_1.default.useState(null), 2), uploadPopover = _b[0], setUploadPopover = _b[1];
    var handleUploadPopover = function (event) {
        setUploadPopover(uploadPopover ? null : event.currentTarget);
    };
    var _c = __read((0, useUploadTransactions_1.useUploadTransactions)(company.id || ''), 1), uploadTransactions = _c[0];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleUploadPopover, sx: { mr: 1 } }, { children: "Uploads" })), (0, jsx_runtime_1.jsx)(material_1.Popover, __assign({ open: !!uploadPopover, anchorEl: uploadPopover, onClose: function () { return setUploadPopover(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2, maxWidth: 500 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Please choose an upload option based on use case" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, mb: 2 }, { children: "General:" })), (0, jsx_runtime_1.jsx)(FlatfileUpload_1.default, __assign({ transactionsCaller: uploadTransactions }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { children: "Upload transactions" }) })), company.isUploadingTransactionsCsv && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "ds-button btn-sm btn-primary disabled" }, { children: "Uploading..." }))), company.uploadError && (0, jsx_runtime_1.jsxs)("p", { children: ["Upload Error ", company.uploadError] })] })) }))] }));
};
exports.default = UploadPopover;
